import axios from 'axios'
import qs from 'qs'
import config from './config'
import common from './common'

const service = axios.create({
    baseURL: (location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn') ? 'https://piyao-api.thecover.cn' : config.baseUrl,
    timeout: 10000
})

service.interceptors.request.use(
	config => {
		// 可自定义一些config配置, 可能会调价一些header头

		return config
	},
	error => {
		// 处理一些请求出错的情况

		console.log(error)
	}
)

service.interceptors.response.use(
	config => {
		// 可自定义一些config配置
		// 可处理接口状态码进行相关操作
		if(config.status == 200) {
			return config.data
		}
	},
	error => {
		// 处理一些请求出错的情况

		console.log(error)
	}
)

const AXIOSWAYS = {
	// get
	get: (url, params = {}) => {
		return new Promise((resolve, reject) => {
			service({
				method: 'get',
				url: url,
				params: params,
			}).then(res => {
				if(res.status == 0) {
					resolve(res.data)
				} else {
					// 全局的一个提示信息
				}
			}).catch(err => {
				reject(err)
			})
		})
	},

	// post
	post: (url, params = {}) => {
		return new Promise((resolve, reject) => {
			service({
				method: 'post',
				url: url,
				data: qs.stringify(params),
				// 也可以处理一些header头
				// headers: {
				// 	'Content-Type': 'application/x-www-form-urlencoded'
				// }
			}).then(res => {
				if(res.status == 0) {
					resolve(res.data)
				} else {
					// 全局的一个提示信息
				}
			}).catch(err => {
				reject(err)
			})
		})
	}
}

// 接口配置
const ApiInfo = {
	getColumnList: '/counterRumour/column/list', // 获取栏目列表
	getBanner: '/counterRumour/banner/list', // 获取首页banner
	getIndexNewsList: '/counterRumour/index/list', // 获取首页新闻列表
	getColumnNews: '/counterRumour/column/newsList', // 获取栏目新闻列表
	getRecommendColumn: '/counterRumour/column/recommend/list', // 获取首页推荐栏目列表
	getSubjects: '/counterRumour/subject/list', // 获取专题列表
	getSubjectDetail: '/counterRumour/subject/detail', // 获取专题详情
	getSearchResult: '/counterRumour/search/list', // 获取搜索结果
	getNewsDetail: '/counterRumour/news/detail', // 获取新闻详情
	getRecommendNews: '/counterRumour/relate/newsList', // 获取推荐新闻列表
	getNextNews: '/counterRumour/news/next', // 获取下一篇新闻
	getWeChatConf: '/wap/counterRumour/weixin/getConf', // 获取微信分享配置信息
	getGroupList: '/counterRumour/column/groupList', // 获取分类列表
	getColumnSubjects: '/counterRumour/getColumnSubjects', // 获取专题专栏集合栏目
	getSubjectList: '/counterRumour/column/subject/list', // 获取专题列表新闻
	getChannelNewsList: '/counterRumour/news/channelNewsList', // 获取频道下新闻列表
	getScChannelNewsList: '/counterRumour/sc/channelNewsList', // 获取川渝辟谣下新闻列表
	getScNextNews: '/counterRumour/sc/news/next', // 获取川渝辟谣下一篇新闻
	getSubjectOfChannelIdAndEntryNews: '/counterRumour/news/getSubjectOfChannelIdAndEntryNews', // 川渝辟谣首页专题列表
	scAndCqColumn: '/counterRumour/scAndCqColumn/list', // 川渝辟谣菜单栏
	getHomeChannel: '/counterRumour/news/getHomePageChannel', // 川渝辟谣固定频道列表
}

// if(common.Attribute.isMb()) { // 一开始以为wap接口要加上wap前缀，最后商定和pc走一样的接口
// 	for(let key in ApiInfo) {
// 		ApiInfo[key] = `wap${ApiInfo[key]}`
// 	}
// }

export { AXIOSWAYS, ApiInfo }